module.exports = __webpack_public_path__ + "img/logo_supplier.0efbcc0c.png";